import axios from "axios";
import { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUserPlus } from "react-icons/fa";

export default function OrderReportTable() {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [sortable, setSortable] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [goToPage, setGoToPage] = useState(0);
  const [orderStatus, setOrderStatus] = useState("");
  const [services, setServices] = useState([]);
  const [selectedCategory, setselectedCategory] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [appliedCategory, setAppliedCategory] = useState("");
  const [appliedFromDate, setAppliedFromDate] = useState("");
  const [appliedToDate, setAppliedToDate] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdf, setPdf] = useState(null);

  const { pageNo } = useParams();
  const navigate = useNavigate(null);

  useEffect(() => {
    setCurrentPage(parseInt(pageNo) || 1);
    setGoToPage(parseInt(pageNo) || 1);
    getOrders();
    getServices();
  }, []);

  useEffect(() => {
    getOrders();
  }, [
    currentPage,
    searchTerm,
    recordsPerPage,
    sortable,
    sortOrder,
    appliedCategory,
    appliedFromDate,
    appliedToDate
  ]);

  const handleTableSort = (column) => {
    let order = "asc";
    if (column === sortable) {
      order = sortOrder === "asc" ? "desc" : "asc";
    }
    setSortable(column);
    setSortOrder(order);
  };

  const handleSearch = () => {
    if (fromDate && toDate && fromDate > toDate) {
      toast.error("From date cannot be greater than To date");
      return;
    }

    setAppliedCategory(selectedCategory);
    setAppliedFromDate(fromDate);
    setAppliedToDate(toDate);

    setCurrentPage(1);
    setGoToPage(1);
  };


  const handleClear = () => {
    setselectedCategory("");
    setFromDate("");
    setToDate("");

    setAppliedCategory("");
    setAppliedFromDate("");
    setAppliedToDate("");

    setCurrentPage(1);
    setGoToPage(1);
  };


  const handlePrevious = () => {
    navigate(
      `/admin-panel/order-report/${currentPage - 1}`
    );
    setCurrentPage(currentPage - 1);
    setGoToPage(currentPage - 1);
  };

  const handleNext = () => {
    navigate(
      `/admin-panel/order-report/${currentPage + 1}`
    );
    setCurrentPage(currentPage + 1);
    setGoToPage(currentPage + 1);
  };

  const handleGoToPage = (page) => {
    if (!page) {
      navigate(`/admin-panel/order-report/${goToPage}`);
    } else {
      navigate(`/admin-panel/order-report/${page}`);
      setCurrentPage(page);
    }
    setGoToPage(page);
  };

  const downloadBase64PDF = (base64Data, filename) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getServices = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/category/view-all-categories?status=Active&page=1&limit=1000&sort=${sortable}`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        setServices(response.data.result.categories);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getOrders = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      if (currentPage < 1) {
        setCurrentPage(1);
        setGoToPage(1);
        setSearchTerm("");
        toast.error("Page number should be greater than or equal to 1");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/order/order-report?page=${currentPage}&search=${searchTerm}&status=${orderStatus}&limit=${recordsPerPage}&sort=${sortable}&sortOrder=${sortOrder}&categoryId=${appliedCategory}&fromDate=${appliedFromDate}&endDate=${appliedToDate}&wantPdf=true`,
        {
          headers: headers,
        }
      );

      console.log("Response", response);

      if (response.data.statusCode === 200) {
        setData(response.data.result.orders);
        setPdf(response.data.result.pdf);
        setTotalRecords(response.data.result.totalRecords);
        setCurrentPage(response.data.result.currentPage);
        setTotalPages(response.data.result.totalPages);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


  return (
    <div>
      {/* Active Orders */}
      <ToastContainer />
      <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
        <div className="flex justify-between items-center">
          <h2 className="md:text-xl text-base font-medium">Order Reports</h2>
          <div className="flex flex-wrap items-end gap-3">

            {/* Service Category */}
            <div className="flex flex-col">
              <label className="text-xs mb-1 text-gray-600">Service Category</label>
              <select
                className="border text-sm h-9 px-2 outline-none w-[200px] rounded"
                value={selectedCategory}
                onChange={(e) => setselectedCategory(e.target.value)}
              >
                <option value="">Select Service Category</option>
                {services.map((service) => (
                  <option key={service._id} value={service._id}>
                    {service.title}
                  </option>
                ))}
              </select>
            </div>

            {/* From Date */}
            <div className="flex flex-col">
              <label className="text-xs mb-1 text-gray-600">From Date</label>
              <input
                type="date"
                className="border text-sm h-9 px-2 outline-none rounded"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="flex flex-col">
              <label className="text-xs mb-1 text-gray-600">To Date</label>
              <input
                type="date"
                className="border text-sm h-9 px-2 outline-none rounded"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            {/* Search */}
            <button
              onClick={handleSearch}
              className="bg-[#01b208] text-white px-5 h-9 rounded text-sm"
            >
              Search
            </button>

            {/* Clear */}
            <button
              onClick={handleClear}
              className="bg-gray-300 text-black px-5 h-9 rounded text-sm"
            >
              Clear
            </button>

            {/* Download PDF */}
            {pdf && (
              <button
                onClick={() => downloadBase64PDF(pdf, "orders_reports.pdf")}
                className="bg-[#c04c4c] text-white h-9 w-9 rounded flex items-center justify-center"
                title="Download PDF"
              >
                <FaDownload size={14} />
              </button>
            )}

          </div>

        </div>
        <div className="flex gap-4 justify-between flex-wrap mt-10 overflow-auto text-sm">
          <table className="w-full text-center">
            <thead>
              <tr className="border-b">

                <td className="font-medium py-4 cursor-pointer">Order Id </td>
                <td className="font-medium py-4 cursor-pointer">Service Category </td>

                <td className="font-medium py-4 cursor-pointer">
                  Customer Name
                </td>
                <td className="font-medium py-4 cursor-pointer">
                  Contact Number
                </td>

                <td className="font-medium py-4 cursor-pointer">Order Status </td>
                <td className="font-medium py-4 cursor-pointer">Driver </td>

                <td className="font-medium py-4 cursor-pointer">Total Amount </td>
                <td className="font-medium py-4 cursor-pointer">Order Date </td>

                <td className="font-medium py-4 cursor-pointer">Actions </td>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                data.length > 0 ? (
                  data.map((item) => (
                    <tr key={item._id} className={`border-b`}>

                      <td className="py-3 text-sm">{item?.orderId}</td>
                      <td className="py-3 text-sm">{item?.serviceCategory}</td>

                      <td className="py-3 text-sm">{item?.customer?.name}</td>
                      <td className="py-3 text-sm">{item?.customer?.phone}</td>

                      <td className="py-3 text-sm">{item?.status}</td>
                      <td className="py-3 text-sm">{item?.driver}</td>
                      <td className="py-3 text-sm">{item?.totalAmount}</td>
                      <td className="py-3 text-sm">{formatDate(item?.orderDate)}</td>

                      <td className="py-3 text-sm flex justify-center gap-x-3">
                        <button
                          className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                          title="View Order"
                          onClick={() => {
                            navigate(
                              `/admin-panel/assigning-job/view/${item._id}`,
                              {
                                state: { data: item },
                              }
                            );
                          }}
                        >
                          <i className="fa fa-eye text-white"></i>
                        </button>

                      </td>
                    </tr>
                  ))
                ) : (
                  <td colSpan={6} className="text-center">
                    <p className="text-center w-full mt-10">No results found</p>
                  </td>
                )
              ) : (
                <td colSpan={6} className="text-center">
                  <p className="text-center w-full mt-10">Loading ...</p>
                </td>
              )}
            </tbody>
          </table>
          <div className="flex justify-between items-center w-full mt-6">
            <div className="">
              <span className="text-[13px] text-gray-500">
                Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                {currentPage * recordsPerPage > totalRecords
                  ? totalRecords
                  : currentPage * recordsPerPage}{" "}
                out of {totalRecords}
              </span>
            </div>
            <div className="flex justify-center items-center gap-x-3">
              <button
                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                disabled={currentPage === 1}
                onClick={handlePrevious}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              <span className="text-[13px] text-gray-500">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                disabled={currentPage === totalPages}
                onClick={handleNext}
              >
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
